var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaylooplogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 40,
    viewBox: "0 0 27 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00983417 33.5986V34.8471C0.00377045 37.4752 2.1382 39.6091 4.77187 39.6091C7.40555 39.6091 9.53594 37.4812 9.53594 34.8552V28.0137C3.16903 30.9665 0.0078125 33.6006 0.0078125 33.6006L0.00983417 33.5986Z",
    fill: "#035C32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00983417 33.5986V34.8471C0.00377045 37.4752 2.1382 39.6091 4.77187 39.6091C7.40555 39.6091 9.53594 37.4812 9.53594 34.8552V28.0137C3.16903 30.9665 0.0078125 33.6006 0.0078125 33.6006L0.00983417 33.5986Z",
    fill: "#035C32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53553 30.07V28.0127C3.28586 30.9111 0.132721 33.4968 0.0195312 33.5916C1.73556 32.6235 4.92306 31.6412 9.53553 30.072V30.07Z",
    fill: "#0C2117"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0496 0.797586L2.77718 3.54669C1.09955 4.18002 0 5.72702 0 7.4495V31.421L0.00808515 31.417V33.5993C0.00808515 33.5993 4.43662 29.9063 13.3745 26.3645L17.3584 24.8598C22.646 22.861 26.1185 17.982 26.1185 12.5524V11.2272C26.1185 3.30869 17.7606 -2.11489 10.0496 0.797586Z",
    fill: "#54BB6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1193 12.5524V11.9271C26.1193 9.26072 25.1694 6.88071 23.6171 5.00293L14.3153 7.74195C12.2395 8.35309 10.8125 10.2551 10.8125 12.4173C10.8125 15.6726 13.9495 18.0123 17.0783 17.0905L26.0587 13.7565C26.0971 13.3592 26.1173 12.9598 26.1173 12.5544L26.1193 12.5524Z",
    fill: "#0C2117"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145 11.7131C10.8145 14.9684 13.9515 17.3081 17.0804 16.3864L26.0607 13.7421C26.0971 13.3488 26.1193 12.9515 26.1193 12.5501V11.225C26.1193 8.55857 25.1694 6.17856 23.6171 4.30078L14.3153 7.0398C12.2395 7.65094 10.8125 9.55293 10.8125 11.7151L10.8145 11.7131Z",
    fill: "#035C32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1057 13.1953C14.6862 13.1953 15.1568 12.7257 15.1568 12.1465C15.1568 11.5672 14.6862 11.0977 14.1057 11.0977C13.5253 11.0977 13.0547 11.5672 13.0547 12.1465C13.0547 12.7257 13.5253 13.1953 14.1057 13.1953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaylooplogo);
export default __webpack_public_path__ + "static/media/paylooplogo.ed983105eea7ac4475cf2296633bd026.svg";
export { ForwardRef as ReactComponent };